import { createHead } from '@unhead/vue/client'
import { createApp } from 'vue'
import App from './App.vue'
import directives from './directives'
import { i18n } from './modules/i18n'
import { nprogress } from './modules/nprogress'
import { pinia } from './modules/pinia'
import { router } from './modules/router'
import './style.css'
import '@eci-saas/shared/overrides.css'
import '@eci-saas/shared/flow-overrides.css'

const head = createHead()

const app = createApp(App)
  .use(router)
  .use(i18n)
  .use(pinia)
  .use(head)
  .use(nprogress)
  .use(directives)

// 初始化用户认证状态
async function initializeApp() {
  // 先挂载应用，让 Pinia 持久化插件有机会工作
  app.mount('#app')
}

// 启动应用
initializeApp().catch(console.error)
